// btw-front/src/pages/AdminNoticeNew.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import Container from "../components/ui/Container";
import NoticeForm from "../components/admin/NoticeForm";
import { create as createNotice, uploadAttachments } from "../api/notices";

export default function AdminNoticeNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // 기본값 published — "등록하면 파트너에게 보인다"가 기본. 숨길 때만 임시저장 선택.
  const [form, setForm] = useState({
    title: "",
    content: "",
    status: "published",
    isPinned: false,
    isFeatured: false,
    notifyPartners: false,
  });
  const [newFiles, setNewFiles] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(ev) {
    ev.preventDefault();
    if (submitting) return;
    if (!form.title.trim() || !form.content.trim()) {
      message.warning(t("admin.notices.toasts.required"));
      return;
    }
    setSubmitting(true);
    try {
      const res = await createNotice({
        title: form.title,
        content: form.content,
        status: form.status,
        isPinned: form.isPinned,
        isFeatured: form.isFeatured,
        notifyPartners: form.notifyPartners,
      });
      if (newFiles.length) {
        // 첨부 실패는 본문 저장 성공과 분리 — 경고만 노출
        try {
          await uploadAttachments(res.id, newFiles);
        } catch (e) {
          message.warning(t("admin.notices.toasts.uploadFailed"));
        }
      }
      message.success(t("admin.notices.toasts.created"));
      navigate("/admin", { replace: true });
    } catch (err) {
      const msg =
        (err && err.payload && err.payload.error && err.payload.error.message) ||
        t("admin.notices.toasts.createFailed");
      message.error(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <Navbar />
      <main className="flex-1 py-10 md:py-14">
        <Container>
          <div className="mx-auto max-w-4xl">
            <h1 className="text-2xl font-bold text-slate-900 md:text-3xl">
              {t("admin.notices.newTitle")}
            </h1>
            <NoticeForm
              form={form}
              setForm={setForm}
              newFiles={newFiles}
              setNewFiles={setNewFiles}
              submitting={submitting}
              onSubmit={handleSubmit}
              cancelTo="/admin"
              submitLabel={t("admin.notices.form.submit")}
              showNotifyPartners
            />
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
